import { useDependencies } from '@servicetitan/react-ioc';
import { useCallback } from 'react';
import { LogoStore } from '../../../auth/stores/logo-store';

// Constants for logo sizing logic
const SIDEBAR_WIDTH = 240;
const MIN_ASPECT_RATIO = 0.3;

export const useLogoVersion = (): ((img: HTMLImageElement | null) => void) => {
    const [{ setDisplayImageInHeader, setNaturalDimensions }] =
        useDependencies<[LogoStore]>(LogoStore);

    const handleImageLoad = useCallback(
        (img: HTMLImageElement | null) => {
            if (!img) {
                return;
            }

            const { naturalHeight, naturalWidth } = img;
            if (naturalWidth === 0 || naturalHeight === 0) {
                setNaturalDimensions(undefined, undefined);
                setDisplayImageInHeader(false);
                return;
            }

            setNaturalDimensions(naturalWidth, naturalHeight);

            const scaledHeight = naturalHeight * (SIDEBAR_WIDTH / naturalWidth);
            const minHeight = MIN_ASPECT_RATIO * SIDEBAR_WIDTH;

            // Wide/short logos go in header, tall logos go in sidebar
            setDisplayImageInHeader(scaledHeight <= minHeight);
        },
        [setDisplayImageInHeader, setNaturalDimensions]
    );

    return handleImageLoad;
};
